<script lang="ts">
	import { page } from '$app/state';
	import { brandsSlugs, getNameWithoutBrand } from '$lib';
	import Price from '$lib/components/Price.svelte';
	import SiblingSelector from '$lib/components/product/SiblingSelector.svelte';
	import ThumbnailImage from '$lib/components/ThumbnailImage.svelte';
	import { m } from '$lib/paraglide/messages';

	import Picto24h from './Picto24h.svelte';

	const {
		product,
		imgLoading = 'lazy',
	}: {
		product: ProductFromCategory;
		imgLoading?: 'eager' | 'lazy';
	} = $props();

	const siblings = $derived(
		[{ slug: product.slug, image: product.image }, ...(product.siblings || [])].filter(
			(item, i, self) => self.findIndex((v) => v.slug === item.slug) === i && item.image,
		),
	);

	let productImage = $derived(product.image);
</script>

<div class="group relative w-full">
	<a class="bg-product relative block aspect-square w-full p-4" href="/{product.slug}">
		{#if product.in_stock}
			<Picto24h icon class="text-xl" />
		{/if}
		{#if productImage}
			<ThumbnailImage
				src="product/{productImage}"
				defaultSize={300}
				maxSize={1200}
				alt={product.slug}
				loading={imgLoading}
				class="aspect-square h-full w-full object-contain mix-blend-darken"
			/>
		{:else}
			<div class="h-full w-full bg-neutral-100"></div>
		{/if}
	</a>

	<div class="h-16 border-b-2 border-b-neutral-300 xl:h-auto">
		<SiblingSelector slug={product.slug} {siblings} bind:selectedImage={productImage} />
	</div>
	<div class="relative pt-0.5">
		<a
			class="font-bold text-neutral-800"
			href="/{brandsSlugs[page.data.store.language]}/{product.brand_slug}">{product.brand}</a
		>
		<a class="mb-1 block text-base break-words" href="/{product.slug}">
			<span>{getNameWithoutBrand(product.name, product.brand)}</span>
		</a>
		<div class="price-box mb-1 inline-block text-sm">
			{#if product.special_price}
				<p class="old-price inline-block text-xs text-neutral-400">
					<span class="price-label whitespace-nowrap">{m.starting_at()}</span>
					<span class="price pr-4 text-xs text-neutral-400 line-through"
						><Price price={product.price} /></span
					>
				</p>
				<p class="special-price">
					<span class="price">
						<Price price={product.special_price} />
					</span>
				</p>
			{:else}
				<span class="regular-price">
					<span class="price"><Price price={product.price} /></span>
				</span>
			{/if}
		</div>
	</div>
</div>
